import { useState, useEffect } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
// import { useNotification } from "context/NotificationContext";

import Api from "utils/Api";
import MaskEnum from "utils/MaskEnum";
import MaskUtil from "utils/MaskUtil";

// Estilos CSS inline
const styles = {
  funcionarioCard: {
    transition: 'all 0.3s ease',
    border: '1px solid #e9ecef',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  funcionarioCardHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
  },
  secaoHeader: {
    borderBottom: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },
  badge: {
    fontSize: '0.75rem',
    fontWeight: '500'
  }
};

const ListaFuncionario = () => {
  const { setLoading } = useLoading();
  const auth = useAuth();
  // const notify = useNotification();
  const Requicicao = new Api();
  const navigate = useNavigate();

  const { StatusFuncionario } = MaskEnum;
  const StateDatafilter = {
    global: { value: null, matchMode: "contains" },
    nome: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    },
    cpf: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    },
    status: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    },
    statusCadastro: {
      operator: "and",
      constraints: [{ value: null, matchMode: "startsWith" }]
    }
  };

  const [filters, setFilters] = useState(StateDatafilter);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [Lista, setLista] = useState([]);

  // Estados para o modal de seleção de empresa
  const [showEmpresaModal, setShowEmpresaModal] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null); // aqui será o ID
  const [listaEmpresas, setListaEmpresas] = useState([]);
  const [tipoAcao, setTipoAcao] = useState(""); // "convite" ou "funcionario"
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [viewMode, setViewMode] = useState("list"); // "cards" ou "list"
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);
  const [selectedStatusCadastro, setSelectedStatusCadastro] = useState([]);
  const [selectedStatusFuncionario, setSelectedStatusFuncionario] = useState([]);

  const onGlobalFilterChange = (e) => {
    try {
      const { value } = e.target;
      const thisFilters = { ...filters };
      thisFilters.global.value = value;
      setFilters(thisFilters);
      setGlobalFilterValue(value);
    } catch (error) {
      console.error(error);
    }
  };

  const InitFilters = () => {
    setFilters(StateDatafilter);
    setGlobalFilterValue("");
  };

  const ClearFilter = () => {
    InitFilters();
  };

  // Carrega empresas em background ao abrir a tela
  const carregarEmpresasBackground = async () => {
    try {
      setLoadingEmpresas(true);
      const resposta = await Requicicao.Get({
        endpoint: "/Empresa/RH/ObterTodos",
        config: auth.GetHeaders()
      });
      if (resposta.codigoEstadoHttp === 200) {
        const empresasFormatadas = resposta.objetoResposta.map((empresa) => ({
          label: `${empresa.pessoa.nomeCompletoOuRazaoSocial} - ${empresa.pessoa.cpfOuCnpj}${empresa.ehMatriz ? ' (Matriz)' : ' (Filial)'}`,
          value: empresa.id,
          nome: empresa.pessoa.nomeCompletoOuRazaoSocial,
          nomeFantasia: empresa.pessoa.apelidoOuNomeFantasia,
          cnpj: empresa.pessoa.cpfOuCnpj,
          ehMatriz: empresa.ehMatriz,
          codigoLoja: empresa.codigoLojaAtual
        }));
        setListaEmpresas(empresasFormatadas);
      }
    } catch (error) {
      console.error("Erro ao carregar empresas em background:", error);
    } finally {
      setLoadingEmpresas(false);
    }
  };

  // Função para abrir modal de seleção de empresa
  const abrirModalEmpresa = (acao) => {
    setTipoAcao(acao);
    setEmpresaSelecionada(null);
    setShowEmpresaModal(true);
  };

  // Função para confirmar seleção de empresa
  const confirmarSelecaoEmpresa = () => {
    if (!empresaSelecionada) {
      // notify && notify({ type: "warning", message: "Por favor, selecione uma empresa." });
      return;
    }
    setShowEmpresaModal(false);
    if (tipoAcao === "convite") {
      navigate(`/app/rh/funcionarios/convite/${empresaSelecionada}`);
    } else if (tipoAcao === "funcionario") {
      navigate(`/app/rh/funcionarios/new/${empresaSelecionada}`);
    }
  };

  const cancelarSelecaoEmpresa = () => {
    setShowEmpresaModal(false);
    setEmpresaSelecionada(null);
    setTipoAcao("");
  };

  useEffect(() => {
    const StateDataPage = async () => {
      try {
        setLoading(true);
        const response = await Requicicao.Get({
          endpoint: "/Funcionarios/All",
          config: auth.GetHeaders()
        });
        if (response.codigoEstadoHttp === 200) {
          setLista(
            response.objetoResposta.map((item) => ({
              ...item,
              status: StatusFuncionario.find((x) => x.value === item.status)
                ?.label
            }))
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    if (auth.isAuthenticated()) {
      StateDataPage();
      carregarEmpresasBackground();
    }
  }, [auth]);

  const SortFuncionario = (a, b) => {
    const dataA = new Date(a.dataAtualizacao || a.dataCriacao);
    const dataB = new Date(b.dataAtualizacao || b.dataCriacao);
    return dataB - dataA;
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 0:
        return "bg-secondary";
      case 1:
        return "bg-warning";
      case 2:
        return "bg-info";
      case 3:
        return "bg-primary";
      case 4:
        return "bg-success";
      case 5:
        return "bg-danger";
      case 6:
        return "bg-danger";
      case 7:
        return "bg-success";
      case 8:
        return "bg-success";
      default:
        return "bg-secondary";
    }
  };

  // Função para filtrar dados baseado nos filtros avançados
  const getFilteredData = () => {
    let filtered = Lista;

    // Filtro por status de cadastro
    if (selectedStatusCadastro.length > 0) {
      filtered = filtered.filter(f => selectedStatusCadastro.includes(f.statusCadastro));
    }

    // Filtro por status do funcionário
    if (selectedStatusFuncionario.length > 0) {
      filtered = filtered.filter(f => selectedStatusFuncionario.includes(f.status));
    }

    return filtered;
  };

  // Obter dados filtrados
  const filteredData = getFilteredData();

  return (
    <div className="card p-3">
      {/* Botões de ação principais */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="d-flex gap-2">
          <Button
            type="button"
            icon="pi pi-user-plus"
            label="Criar Funcionário"
            className="btn btn-primary"
            onClick={() => abrirModalEmpresa("funcionario")}
          />
          <Button
            type="button"
            icon="pi pi-envelope"
            label="Criar Convite"
            className="btn btn-success"
            onClick={() => abrirModalEmpresa("convite")}
          />
        </div>
        <div className="d-flex align-items-center gap-3">
            <div className="btn-group" role="group">
              <Button
                type="button"
                icon="pi pi-th-large"
                className={`btn ${viewMode === "cards" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("cards")}
                tooltip="Visualização em Cards"
              />
              <Button
                type="button"
                icon="pi pi-list"
                className={`btn ${viewMode === "list" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setViewMode("list")}
                tooltip="Visualização em Lista"
              />
            </div>
          <Button
            type="button"
            icon="pi pi-filter-slash"
            label="Limpar filtro"
            outlined
            onClick={ClearFilter}
          />
          <span className="p-input-icon-left">
            <i className="pi pi-search me-2" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Pesquisa Global"
              style={{ width: "300px", paddingLeft: "2.5rem" }}
            />
          </span>
        </div>
      </div>
            {/* Seções de Funcionários */}
      <div className="funcionarios-secoes">
                   {/* Filtros Avançados */}
           <div className="mt-3 mb-4">
             <Button
               type="button"
               className="btn btn-outline-secondary btn-sm"
               onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
             >
               <i className={`pi ${showAdvancedFilters ? "pi-chevron-up" : "pi-chevron-down"} me-1`} />
               Filtros Avançados
             </Button>
             
             {showAdvancedFilters && (
               <div className="mt-3 p-3 border rounded bg-light">
                 <div className="row">
                                        <div className="col-md-6">
                       <h6 className="mb-2">
                         <i className="pi pi-file-edit me-2 text-primary" />
                         Status de Cadastro
                       </h6>
                                                <div className="d-flex flex-wrap gap-3">
                           {MaskEnum.StatusCadastroFuncionari.map((status, index) => {
                           const isSelected = selectedStatusCadastro.includes(index + 1);
                           const getStatusIcon = (statusIndex) => {
                             switch (statusIndex) {
                               case 1: return "pi pi-plus-circle"; // Cadastro Iniciado
                               case 2: return "pi pi-envelope"; // Convite Enviado
                               case 3: return "pi pi-clock"; // Aguardando Preenchimento
                               case 4: return "pi pi-file-pdf"; // Documentos Submetidos
                               case 5: return "pi pi-check-circle"; // Documentos Aprovados
                               case 6: return "pi pi-exclamation-triangle"; // Documentos Reprovados
                               case 7: return "pi pi-pencil"; // Aguardando Assinatura
                               case 8: return "pi pi-check-square"; // Processo Concluído
                               default: return "pi pi-circle";
                             }
                           };
                           return (
                             <Button
                               key={`status-cadastro-${index + 1}`}
                               type="button"
                               className={`btn px-3 py-2 ${
                                 isSelected
                                   ? "btn-primary"
                                   : "btn-outline-primary"
                               }`}
                               onClick={() => {
                                 const newSelection = selectedStatusCadastro.includes(index + 1)
                                   ? selectedStatusCadastro.filter(s => s !== index + 1)
                                   : [...selectedStatusCadastro, index + 1];
                                 setSelectedStatusCadastro(newSelection);
                               }}
                             >
                               <i className={`${getStatusIcon(index + 1)} me-2`} />
                               {status}
                             </Button>
                           );
                         })}
                       </div>
                     </div>
                     
                     <div className="col-md-6">
                       <h6 className="mb-2">
                         <i className="pi pi-user me-2 text-success" />
                         Status do Funcionário
                       </h6>
                                                <div className="d-flex flex-wrap gap-3">
                           {MaskEnum.StatusFuncionario.map((status) => {
                           const isSelected = selectedStatusFuncionario.includes(status.label);
                           const getStatusIcon = (statusLabel) => {
                             switch (statusLabel) {
                               case "Ativo": return "pi pi-check-circle";
                               case "Desligado": return "pi pi-times-circle";
                               case "Não Contratado": return "pi pi-user-minus";
                               case "Desligamento": return "pi pi-sign-out";
                               case "Doença": return "pi pi-heart";
                               case "Férias": return "pi pi-calendar";
                               case "Licença Maternidade/Paternidade": return "pi pi-home";
                               default: return "pi pi-user";
                             }
                           };
                           return (
                             <Button
                               key={status.value}
                               type="button"
                               className={`btn px-3 py-2 ${
                                 isSelected
                                   ? "btn-success"
                                   : "btn-outline-success"
                               }`}
                               onClick={() => {
                                 const newSelection = selectedStatusFuncionario.includes(status.label)
                                   ? selectedStatusFuncionario.filter(s => s !== status.label)
                                   : [...selectedStatusFuncionario, status.label];
                                 setSelectedStatusFuncionario(newSelection);
                               }}
                             >
                               <i className={`${getStatusIcon(status.label)} me-2`} />
                               {status.label}
                             </Button>
                           );
                         })}
                       </div>
                     </div>
                 </div>
                 
                                    {(selectedStatusCadastro.length > 0 || selectedStatusFuncionario.length > 0) && (
                     <div className="mt-3 pt-3 border-top">
                       <div className="d-flex align-items-center justify-content-between">
                         <div className="d-flex align-items-center">
                           <i className="pi pi-filter text-muted me-2" />
                           <small className="text-muted">
                             {selectedStatusCadastro.length + selectedStatusFuncionario.length} filtro(s) ativo(s)
                           </small>
                         </div>
                         <Button
                           type="button"
                           className="btn btn-outline-danger btn-sm"
                           onClick={() => {
                             setSelectedStatusCadastro([]);
                             setSelectedStatusFuncionario([]);
                           }}
                         >
                           <i className="pi pi-times me-1" />
                           Limpar Filtros
                         </Button>
                       </div>
                     </div>
                   )}
               </div>
             )}
           </div>
           
           {/* Seção: Processo Concluído */}
        {(() => {
          const funcionariosConcluidos = filteredData.filter(f => f.statusCadastro === 8);
          if (funcionariosConcluidos.length === 0) return null;
          
          return (
            <div className="secao-funcionarios mb-4">
              <div className="secao-header bg-success text-white p-3 rounded-top">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h5 className="mb-0">
                      <i className="pi pi-check-circle me-2" />
                      Processo Concluído
                    </h5>
                    <small className="opacity-75">
                      {funcionariosConcluidos.length} funcionário{funcionariosConcluidos.length !== 1 ? 's' : ''}
                    </small>
                  </div>
                  <div className="d-flex gap-2">
                    {(() => {
                      const ativos = funcionariosConcluidos.filter(f => f.status === "Ativo").length;
                      const desligados = funcionariosConcluidos.filter(f => f.status === "Desligado").length;
                      const outros = funcionariosConcluidos.length - ativos - desligados;
                      
                      return (
                        <>
                          {ativos > 0 && (
                            <span className="badge bg-light text-success">
                              {ativos} Ativo{ativos !== 1 ? 's' : ''}
                            </span>
                          )}
                          {desligados > 0 && (
                            <span className="badge bg-light text-danger">
                              {desligados} Desligado{desligados !== 1 ? 's' : ''}
                            </span>
                          )}
                          {outros > 0 && (
                            <span className="badge bg-light text-secondary">
                              {outros} Outro{outros !== 1 ? 's' : ''}
                            </span>
                          )}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
              <div className="secao-content p-3 bg-light rounded-bottom">
                {viewMode === "cards" ? (
                  <div className="row">
                    {funcionariosConcluidos.map((funcionario) => (
                      <div key={funcionario.id} className="col-md-6 col-lg-4 mb-3">
                        <div 
                          className="card funcionario-card h-100"
                          style={styles.funcionarioCard}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = styles.funcionarioCardHover.transform;
                            e.currentTarget.style.boxShadow = styles.funcionarioCardHover.boxShadow;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = styles.funcionarioCard.transform;
                            e.currentTarget.style.boxShadow = styles.funcionarioCard.boxShadow;
                          }}
                        >
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <h6 className="card-title mb-0">{funcionario.nome}</h6>
                              <span 
                                className={`badge ${getStatusBadgeClass(funcionario.status)}`}
                                style={styles.badge}
                              >
                                {funcionario.status}
                              </span>
                            </div>
                            <p className="card-text text-muted small mb-2">
                              <i className="pi pi-id-card me-1" />
                              {MaskUtil.applyCpfMask(funcionario.cpf)}
                            </p>
                            <p className="card-text text-muted small mb-2">
                              <i className="pi pi-building me-1" />
                              {funcionario.empresaNome}
                            </p>
                            <div className="d-flex gap-2 mb-3">
                              <span className="badge bg-info text-white small">
                                <i className="pi pi-tag me-1" />
                                {funcionario.empresaCodigoLoja || "N/A"}
                              </span>
                              {funcionario.empresaAlocacaoNome && (
                                <span className="badge bg-secondary text-white small">
                                  <i className="pi pi-map-marker me-1" />
                                  {funcionario.empresaAlocacaoCodigoLoja || "N/A"}
                                </span>
                              )}
                            </div>
                            <div className="d-flex gap-1">
                              <Button
                                size="small"
                                icon="pi pi-pencil"
                                className="btn-outline-primary btn-sm"
                                onClick={() => navigate(`/app/rh/funcionarios/editar/${funcionario.id}`)}
                                tooltip="Editar"
                              />
                              <Button
                                size="small"
                                icon="pi pi-building"
                                className="btn-outline-secondary btn-sm"
                                onClick={() =>
                                  navigate({
                                    pathname: "/app/rh/funcionarios/contratados",
                                    search: createSearchParams({
                                      filial: funcionario.empresaId,
                                      matriz: funcionario.matrizId,
                                      filtro: funcionario.cpf
                                    }).toString()
                                  })
                                }
                                tooltip="Ver Empresa"
                              />
                              <Button
                                size="small"
                                icon="pi pi-users"
                                className="btn-outline-success btn-sm"
                                onClick={() =>
                                  navigate({
                                    pathname: "/app/rh/funcionarios/alocados",
                                    search: createSearchParams({
                                      filial: funcionario.empresaAlocacaoId,
                                      matriz: funcionario.matrizId,
                                      filtro: funcionario.cpf
                                    }).toString()
                                  })
                                }
                                disabled={funcionario.empresaAlocacaoId == null}
                                tooltip="Ver Alocação"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                                 ) : (
      <DataTable
                       value={funcionariosConcluidos}
        stripedRows
        paginator
                       rows={10}
        emptyMessage="Nenhum funcionário encontrado."
                       globalFilterFields={["nome", "cpf", "empresaNome", "empresaCodigoLoja", "empresaAlocacaoCodigoLoja", "status"]}
        filters={filters}
                       tableStyle={{ minWidth: "50rem" }}
      >
                       <Column field="nome" header="Nome" sortable style={{ width: "20%" }} />
        <Column
          field="cpf"
          header="CPF"
          sortable
          body={(row) => MaskUtil.applyCpfMask(row.cpf)}
                         style={{ width: "12%" }}
                       />
                       <Column field="empresaNome" header="Empresa" sortable style={{ width: "20%" }} />
                       <Column
                         field="empresaCodigoLoja"
                         header="Código Contratado"
                         sortable
                         body={(row) => (
                           <span className="badge bg-info text-white">
                             {row.empresaCodigoLoja || "N/A"}
                           </span>
                         )}
                         style={{ width: "12%" }}
                       />
                       <Column
                         field="empresaAlocacaoCodigoLoja"
                         header="Código Alocado"
                         sortable
                         body={(row) => (
                           <span className="badge bg-secondary text-white">
                             {row.empresaAlocacaoCodigoLoja || "N/A"}
                           </span>
                         )}
                         style={{ width: "12%" }}
                       />
        <Column
                         field="status"
                         header="Status"
          sortable
                         body={(row) => (
                           <span 
                             className={`badge ${getStatusBadgeClass(row.status)}`}
                             style={styles.badge}
                           >
                             {row.status}
                           </span>
                         )}
                         style={{ width: "12%" }}
        />
        <Column
                         header="Ações"
          body={(row) => (
                         <div className="d-flex gap-1">
                           <Button
                             size="small"
                             icon="pi pi-pencil"
                             className="btn-outline-primary btn-sm"
                             onClick={() => navigate(`/app/rh/funcionarios/editar/${row.id}`)}
                             tooltip="Editar"
                             tooltipOptions={{ position: "top", className: "text-xs" }}
                           />
                           <Button
                             size="small"
                             icon="pi pi-building"
                             className="btn-outline-secondary btn-sm"
                             onClick={() =>
                               navigate({
                                 pathname: "/app/rh/funcionarios/contratados",
                                 search: createSearchParams({
                                   filial: row.empresaId,
                                   matriz: row.matrizId,
                                   filtro: row.cpf
                                 }).toString()
                               })
                             }
                             tooltip="Ver Empresa"
                             tooltipOptions={{ position: "top", className: "text-xs" }}
                           />
                           <Button
                             size="small"
                             icon="pi pi-users"
                             className="btn-outline-success btn-sm"
                             onClick={() =>
                               navigate({
                                 pathname: "/app/rh/funcionarios/alocados",
                                 search: createSearchParams({
                                   filial: row.empresaAlocacaoId,
                                   matriz: row.matrizId,
                                   filtro: row.cpf
                                 }).toString()
                               })
                             }
                             disabled={row.empresaAlocacaoId == null}
                             tooltip="Ver Alocação"
                             tooltipOptions={{ position: "top", className: "text-xs" }}
                           />
                         </div>
                       )}
                     />
                   </DataTable>
                 )}
              </div>
            </div>
          );
        })()}

        {/* Seção: Em Processo */}
        {(() => {
          const funcionariosEmProcesso = filteredData.filter(f => f.statusCadastro !== 8);
          if (funcionariosEmProcesso.length === 0) return null;
          
          // Agrupar por status de cadastro
          const grupos = {};
          funcionariosEmProcesso.forEach(f => {
            const statusLabel = MaskEnum.StatusCadastroFuncionari[f.statusCadastro - 1] || "Não definido";
            if (!grupos[statusLabel]) grupos[statusLabel] = [];
            grupos[statusLabel].push(f);
          });
          
          return (
            <div className="secao-funcionarios mb-4">
              <div className="secao-header bg-warning text-dark p-3 rounded-top">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h5 className="mb-0">
                      <i className="pi pi-clock me-2" />
                      Em Processo
                    </h5>
                    <small className="opacity-75">
                      {funcionariosEmProcesso.length} funcionário{funcionariosEmProcesso.length !== 1 ? 's' : ''}
                    </small>
                  </div>
                </div>
              </div>
                             <div className="secao-content p-3 bg-light rounded-bottom">
                 {viewMode === "cards" ? (
                   Object.entries(grupos).map(([statusLabel, funcionarios]) => (
                     <div key={statusLabel} className="grupo-status mb-4">
                       <div className="grupo-header d-flex align-items-center mb-3">
                         <h6 className="mb-0 me-3">{statusLabel}</h6>
                         <span className="badge bg-secondary">{funcionarios.length}</span>
                       </div>
                       <div className="row">
                         {funcionarios.map((funcionario) => (
                           <div key={funcionario.id} className="col-md-6 col-lg-4 mb-3">
                             <div 
                               className="card funcionario-card h-100 border-warning"
                               style={styles.funcionarioCard}
                               onMouseEnter={(e) => {
                                 e.currentTarget.style.transform = styles.funcionarioCardHover.transform;
                                 e.currentTarget.style.boxShadow = styles.funcionarioCardHover.boxShadow;
                               }}
                               onMouseLeave={(e) => {
                                 e.currentTarget.style.transform = styles.funcionarioCard.transform;
                                 e.currentTarget.style.boxShadow = styles.funcionarioCard.boxShadow;
                               }}
                             >
                               <div className="card-body">
                                 <div className="d-flex justify-content-between align-items-start mb-2">
                                   <h6 className="card-title mb-0">{funcionario.nome}</h6>
                                   <span 
                                     className={`badge ${getStatusBadgeClass(funcionario.status)}`}
                                     style={styles.badge}
                                   >
                                     {funcionario.status}
                                   </span>
                                 </div>
                                 <p className="card-text text-muted small mb-2">
                                   <i className="pi pi-id-card me-1" />
                                   {MaskUtil.applyCpfMask(funcionario.cpf)}
                                 </p>
                                 <p className="card-text text-muted small mb-2">
                                   <i className="pi pi-building me-1" />
                                   {funcionario.empresaNome}
                                 </p>
                                 <div className="d-flex gap-2 mb-3">
                                   <span className="badge bg-info text-white small">
                                     <i className="pi pi-tag me-1" />
                                     {funcionario.empresaCodigoLoja || "N/A"}
                                   </span>
                                   {funcionario.empresaAlocacaoNome && (
                                     <span className="badge bg-secondary text-white small">
                                       <i className="pi pi-map-marker me-1" />
                                       {funcionario.empresaAlocacaoCodigoLoja || "N/A"}
                                     </span>
                                   )}
                                 </div>
                                 <div className="d-flex gap-1">
              <Button
                                     size="small"
                icon="pi pi-pencil"
                                     className="btn-outline-primary btn-sm"
                                     onClick={() => navigate(`/app/rh/funcionarios/editar/${funcionario.id}`)}
                                     tooltip="Editar"
                                   />
                                   <Button
                                     size="small"
                                     icon="pi pi-building"
                                     className="btn-outline-secondary btn-sm"
                                     onClick={() =>
                                       navigate({
                                         pathname: "/app/rh/funcionarios/contratados",
                                         search: createSearchParams({
                                           filial: funcionario.empresaId,
                                           matriz: funcionario.matrizId,
                                           filtro: funcionario.cpf
                                         }).toString()
                                       })
                                     }
                                     tooltip="Ver Empresa"
                                   />
                                   <Button
                                     size="small"
                                     icon="pi pi-users"
                                     className="btn-outline-success btn-sm"
                onClick={() =>
                                       navigate({
                                         pathname: "/app/rh/funcionarios/alocados",
                                         search: createSearchParams({
                                           filial: funcionario.empresaAlocacaoId,
                                           matriz: funcionario.matrizId,
                                           filtro: funcionario.cpf
                                         }).toString()
                                       })
                                     }
                                     disabled={funcionario.empresaAlocacaoId == null}
                                     tooltip="Ver Alocação"
                                   />
                                 </div>
                               </div>
                             </div>
                           </div>
                         ))}
                       </div>
                     </div>
                   ))
                                    ) : (
                     Object.entries(grupos).map(([statusLabel, funcionarios]) => (
                       <div key={statusLabel} className="grupo-status mb-4">
                         <div className="grupo-header d-flex align-items-center mb-3">
                           <h6 className="mb-0 me-3 fw-bold">{statusLabel}</h6>
                           <span className="badge bg-secondary">{funcionarios.length}</span>
                         </div>
                         <DataTable
                           value={funcionarios}
                           stripedRows
                           paginator
                           rows={10}
                           emptyMessage="Nenhum funcionário encontrado."
                           globalFilterFields={["nome", "cpf", "empresaNome", "empresaCodigoLoja", "empresaAlocacaoCodigoLoja", "status"]}
                           filters={filters}
                           tableStyle={{ minWidth: "50rem" }}
                         >
                           <Column field="nome" header="Nome" sortable style={{ width: "25%" }} />
                           <Column
                             field="cpf"
                             header="CPF"
                             sortable
                             body={(row) => MaskUtil.applyCpfMask(row.cpf)}
                             style={{ width: "15%" }}
                           />
                           <Column field="empresaNome" header="Empresa" sortable style={{ width: "20%" }} />
                           <Column
                             field="statusCadastro"
                             header="Status de Cadastro"
                             sortable
                             body={(row) => (
                               <span 
                                 className={`badge ${getStatusBadgeClass(row.statusCadastro)}`}
                                 style={styles.badge}
                               >
                                 {MaskEnum.StatusCadastroFuncionari[row.statusCadastro - 1]}
                               </span>
                             )}
                             style={{ width: "15%" }}
                           />
                           <Column
                             field="empresaCodigoLoja"
                             header="Código Contratado"
                             sortable
                             body={(row) => (
                               <span className="badge bg-info text-white">
                                 {row.empresaCodigoLoja || "N/A"}
                               </span>
                             )}
                             style={{ width: "12%" }}
                           />
                           <Column
                             field="empresaAlocacaoCodigoLoja"
                             header="Código Alocado"
                             sortable
                             body={(row) => (
                               <span className="badge bg-secondary text-white">
                                 {row.empresaAlocacaoCodigoLoja || "N/A"}
                               </span>
                             )}
                             style={{ width: "12%" }}
                           />
                           <Column
                             header="Ações"
                             style={{ width: "16%" }}
                             body={(row) => (
                               <div className="d-flex gap-1">
                                 <Button
                                   size="small"
                                   icon="pi pi-pencil"
                                   className="btn-outline-primary btn-sm"
                                   onClick={() => navigate(`/app/rh/funcionarios/editar/${row.id}`)}
                                   tooltip="Editar"
                                   tooltipOptions={{ position: "top", className: "text-xs" }}
              />
              <Button
                                   size="small"
                icon="pi pi-building"
                                   className="btn-outline-secondary btn-sm"
                onClick={() =>
                  navigate({
                    pathname: "/app/rh/funcionarios/contratados",
                    search: createSearchParams({
                      filial: row.empresaId,
                      matriz: row.matrizId,
                      filtro: row.cpf
                    }).toString()
                  })
                }
                                   tooltip="Ver Empresa"
                                   tooltipOptions={{ position: "top", className: "text-xs" }}
              />
              <Button
                                   size="small"
                icon="pi pi-users"
                                   className="btn-outline-success btn-sm"
                onClick={() =>
                  navigate({
                    pathname: "/app/rh/funcionarios/alocados",
                    search: createSearchParams({
                      filial: row.empresaAlocacaoId,
                      matriz: row.matrizId,
                      filtro: row.cpf
                    }).toString()
                  })
                }
                disabled={row.empresaAlocacaoId == null}
                                   tooltip="Ver Alocação"
                                   tooltipOptions={{ position: "top", className: "text-xs" }}
              />
            </div>
          )}
        />
      </DataTable>
                       </div>
                     ))
                   )}
               </div>
            </div>
          );
        })()}

        {/* Mensagem quando não há funcionários */}
        {filteredData.length === 0 && (
          <div className="text-center py-5">
            <i className="pi pi-users fs-1 text-muted mb-3" />
            <h5 className="text-muted">Nenhum funcionário encontrado</h5>
            <p className="text-muted">Não há funcionários cadastrados no sistema.</p>
            </div>
          )}
      </div>
      {/* Modal de seleção de empresa */}
      <Dialog
        header="Selecionar Empresa"
        visible={showEmpresaModal}
        style={{ width: "50vw" }}
        modal
        onHide={cancelarSelecaoEmpresa}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Cancelar"
              icon="pi pi-times"
              className="btn btn-secondary"
              onClick={cancelarSelecaoEmpresa}
            />
            <Button
              label="Confirmar"
              icon="pi pi-check"
              className="btn btn-primary"
              onClick={confirmarSelecaoEmpresa}
              disabled={!empresaSelecionada || loadingEmpresas}
            />
          </div>
        }
      >
        <div className="mb-3">
          <p className="text-muted">
            {tipoAcao === "convite"
              ? "Selecione a empresa para criar um convite de funcionário:"
              : "Selecione a empresa para cadastrar um novo funcionário:"}
          </p>
        </div>
        <div className="mb-3">
          <label htmlFor="empresa" className="form-label">
            Empresa *
          </label>
          {loadingEmpresas ? (
            <div className="alert alert-info">
              <i className="pi pi-spin pi-spinner me-2" />
              Carregando lista de empresas...
            </div>
          ) : (
            <Dropdown
              id="empresa"
              value={empresaSelecionada}
              options={listaEmpresas}
              onChange={(e) => setEmpresaSelecionada(e.value)}
              placeholder="Selecione uma empresa..."
              className="w-100"
              showClear
              filter
              filterPlaceholder="Buscar empresa..."
              style={{ minHeight: "40px" }}
              optionLabel="label"
              optionValue="value"
            />
          )}
        </div>
        {empresaSelecionada && (() => {
          const empresaCompleta = listaEmpresas.find(emp => emp.value === empresaSelecionada);
          return empresaCompleta ? (
            <div className="alert alert-info">
              <strong>Empresa selecionada:</strong> {empresaCompleta.nome}
              <br />
              <strong>Nome Fantasia:</strong> {empresaCompleta.nomeFantasia || "N/A"}
              <br />
              <strong>CNPJ:</strong> {empresaCompleta.cnpj || "N/A"}
              <br />
              <strong>Tipo:</strong> {empresaCompleta.ehMatriz ? "Matriz" : "Filial"}
              <br />
              <strong>Código da Loja:</strong> {empresaCompleta.codigoLoja || "N/A"}
            </div>
          ) : null;
        })()}
      </Dialog>
    </div>
  );
};
export default ListaFuncionario;
